import React from "react";
import { Box, Typography, Avatar } from "@mui/material";

const testimonials = [
  {
    name: "Rahul & Sneha",
    location: "Madhurawada, Visakhapatnam",
    text: "Arc Studioz made our dream 3BHK a reality. The team was transparent about costs and completed the work on time, even with design changes.",
    img: "/images/testimonials/rahul-sneha.jpg",
  },
  {
    name: "Lakshmi Prasad",
    location: "Gajuwaka, Visakhapatnam",
    text: "From structural planning to the final finishes, Arc Studioz handled everything. Their site supervision and quality of materials were excellent.",
    img: "/images/testimonials/lakshmi-prasad.jpg",
  },
  {
    name: "Ravi Kumar",
    location: "MVP Colony, Visakhapatnam",
    text: "We were worried about managing construction while working in Hyderabad. Arc Studioz gave regular updates and handed over our house exactly as promised.",
    img: "/images/testimonials/ravi-kumar.jpg",
  },
];

const Testimonials = () => {
  return (
    <Box sx={{ py: 10, px: { xs: 3, md: 10 }, backgroundColor: "#faf7f2" }}>
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          mb: 6,
          fontWeight: 600,
          color: "#b2925a",
          fontFamily: "serif",
        }}
      >
        What Our Clients Say
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 4,
        }}
      >
        {testimonials.map((t, i) => (
          <Box
            key={i}
            sx={{
              p: 3,
              borderRadius: 3,
              backgroundColor: "#fff",
              boxShadow: "0 16px 40px -28px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              height: "100%",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Avatar
                src={t.img}
                alt={t.name}
                sx={{ width: 56, height: 56 }}
              />
              <Box>
                <Typography sx={{ fontWeight: 600 }}>{t.name}</Typography>
                <Typography sx={{ fontSize: 14, color: "#777" }}>
                  {t.location}
                </Typography>
              </Box>
            </Box>

            <Typography sx={{ color: "#444", mt: 1, flexGrow: 1 }}>
              “{t.text}”
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Testimonials;
